<template lang="pug">
v-container.py-8
  v-sheet.mx-auto(max-width="1080px")
    grid-container.align-center(
      v-if="content.text",
      cols="auto",
      cols-md="50% 50%",
      gap="32px",
      gap-md="80px"
    ) 
      div
        custom-title.mb-4 {{ content.title }}
        .text--secondary(v-html="content.text")
      img.page-home-about-img.rounded-sm(
        :src="files + content.img",
        :alt="content.title"
      )
</template>

<script>
import CustomTitle from "../../shell/CustomTitle.vue";

const _config = {
  mod: "about",
};

export default {
  computed: {
    content() {
      return this.$rest(_config.mod).item;
    },
  },
  beforeCreate() {
    this.$rest(_config.mod).get({ save: (state, data) => (state.item = data) });
  },
  components: {
    CustomTitle,
  },
};
</script>

<style>
.page-home-about-img {
  width: 100%;
  object-fit: cover;
}
</style>